import { Accordion, Box, Heading, RichText } from '@ads-core/components';
import { useState } from 'react';

export const Attachment = ({ title, text }: { title: string; text: string }) => {
  const [isOpen, setIsOpen] = useState({ id: title, opened: true });

  return (
    <Box>
      <Accordion
        type="single"
        activeIds={isOpen.id}
        onAccordionOpen={(id, opened) => setIsOpen({ id, opened })}
      >
        <Accordion.Container>
          <Accordion.Item
            isActive={isOpen.id === title}
            title={
              <Heading size="h4" as="h2">
                {title}
              </Heading>
            }
            content={
              <Box paddingTop={10}>
                <RichText>{text}</RichText>
              </Box>
            }
            id={title}
            icon={<Accordion.Icon isActive={isOpen.id === title} />}
          />
        </Accordion.Container>
      </Accordion>
    </Box>
  );
};
